import { render, staticRenderFns } from "./newBill.vue?vue&type=template&id=cd098f6c&scoped=true&"
import script from "./newBill.vue?vue&type=script&lang=js&"
export * from "./newBill.vue?vue&type=script&lang=js&"
import style0 from "./newBill.vue?vue&type=style&index=0&id=cd098f6c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd098f6c",
  null
  
)

export default component.exports